import axios from 'axios';
import * as Config from '../../config';

const state = {};

const actions = {

    profile_getUser({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'profile/get-user', form)
                .then(
                    response => {
                        resolve(response.data);
                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    profile_updateUser({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {

            axios.post(Config.apiPath + 'profile/update-user', form)
                .then(
                    response => {
                        resolve(response.data);
                    })
                .catch(error => {
                    reject(error.response.data);
                });
        });
    },
    profile_saveAvatar({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'profile/save-avatar', form, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then(
                    response => {
                        resolve(response.data)

                    })
                .catch(error => {
                    console.log('error', error);
                    reject(error.response.data)
                })
        });
    },
    profile_savePdfLogo({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'profile/save-pdf-logo', form, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then(
                    response => {
                        resolve(response.data)

                    })
                .catch(error => {
                    console.log('error', error);
                    reject(error.response.data)
                })
        });
    },
    profile_deletePdfLogo({ commit, dispatch }, id) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'profile/delete-pdf-logo', { id: id })
                .then(
                    response => {
                        resolve(response.data)
                    })
                .catch(error => {
                    console.log('error', error);
                    reject(error.response.data)
                })
        });
    },
};

const mutations = {};

export default {
    state,
    actions,
    mutations
};